import { network } from 'services/network';

export const getActivityMainDetailsByTaskdId = (params) => {
    const url = `api/bo/getActivityMainDetailsByTaskdId?taskId=${params}`;

    return network.get(url).then((response) => {
        return response.data;
    });
};
